import { useEffect } from "react";

export default function Toast({
  message,
  onDismiss,
  durationMs = 5000,
}: {
  message: string;
  onDismiss: () => void;
  durationMs?: number;
}) {
  useEffect(() => {
    const t = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(t);
  }, [onDismiss, durationMs]);

  return (
    <div
      role="status"
      className="fixed inset-x-4 top-[calc(env(safe-area-inset-top)+0.75rem)] z-30 mx-auto max-w-sm rounded-card bg-forest-700 px-4 py-3 text-sm text-canvas shadow-lg"
    >
      <div className="flex items-start justify-between gap-3">
        <span>{message}</span>
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className="h-tap w-8 shrink-0 text-canvas/80"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
